import React from 'react';
import { connect } from 'react-redux';

import BillingDetailsCard from './BillingDetailsCard';

import * as billingSelectors from '../../../../redux/auth/billing/selectors';
import * as authUserSelectors from '../../../../redux/auth/user/selectors';

const BillingDetailsCardConnected = (props) => <BillingDetailsCard {...props} />;

const mapStateToProps = (state) => ({
  address: {
    city: billingSelectors.selectAddressCity(state),
    country: billingSelectors.selectAddressCountryName(state),
    line1: billingSelectors.selectAddressLine1(state),
    line2: billingSelectors.selectAddressLine2(state),
    postalCode: billingSelectors.selectAddressPostalCode(state),
    state: billingSelectors.selectAddressState(state),
  },
  cardExpiration: billingSelectors.selectCardExpiration(state),
  cardNumber: billingSelectors.selectCardNumber(state),
  error: billingSelectors.selectError(state),
  errorMessage: billingSelectors.selectErrorMessage(state),
  isLoading: billingSelectors.selectIsLoading(state),

  isUserStandard: authUserSelectors.selectIsUserStandard(state),
});

export default connect(mapStateToProps)(BillingDetailsCardConnected);
